export default __webpack_public_path__ + "static/media/CNo.71-2.84db4d48.jpg";